import React from "react";
import {Route, Routes} from 'react-router-dom'
import { Contact } from "./Components/Routes/Contact Form/contact";
import { Science } from "./Components/Routes/Science/Science";
import { Structure } from "./Structure";
import { Experiments } from "./Components/Routes/Experiments/Experiments";
import { GraphOG } from "./Components/Routes/GraphOFGrowth/GoG";
import { Ideas } from "./Components/Routes/Ideas/Ideas";
import { Mindmaps } from './Components/Routes/Mindmaps/Mindmaps'
import { Models } from "./Components/Routes/Models/Models";
import { Modules } from "./Components/Routes/Modules/Modules";
import { Activities } from "./Components/Routes/Activities/Activities";
import { EarthDay } from "./Components/Routes/EarthDay/ED";
import { Dglands } from "./Components/Routes/Activities/DGGlands/Dglands";
import { Crd_Copper } from "./Components/Routes/Activities/CRD Copper/Coppr";
import { SootCarbon } from "./Components/Routes/Activities/SootUSCarbon/Soot";
import { SoilPH } from "./Components/Routes/Activities/SoilPH/SoilPH";
import { Earlobes } from "./Components/Routes/Activities/Earlobes/Earlobes";
import { Series } from "./Components/Routes/Activities/Circuts/Series";
import { Parallel } from "./Components/Routes/Activities/Circuts/Parallel";
import { Dispersion } from "./Components/Routes/Activities/Dispersion/Dispersion";
const Paths = () => {
    return(
        <>
            <Routes>
                <Route path="/" element={<Structure />} />
                <Route path="/contact" element={<Contact />}/>
                <Route path="/science" element={<Science />}/>
                <Route path="/science/experiments" element={<Experiments />}/>
                <Route path="/science/graphOG" element={<GraphOG />}/>
                <Route path="/science/ideas" element={<Ideas />}/>
                <Route path="/science/mindmaps" element={<Mindmaps />}/>
                <Route path="/science/models" element={<Models />}/>
                <Route path="/science/modules" element={<Modules />}/>
                <Route path="/science/activities" element={<Activities />} />
                <Route path="/science/earthday" element={<EarthDay />} />
                <Route path="/science/activity/DigestiveGlands/" element={ <Dglands /> } />
                <Route path='/science/activity/CRD_COPPER' element={ <Crd_Copper /> } />
                <Route path="/science/activity/SootCarbon" element={ <SootCarbon /> } />
                <Route path="/science/activity/Soil-PH" element={ <SoilPH /> } />
                <Route path="/science/activity/Earlobes" element={ <Earlobes /> } />
                <Route path="/science/activity/Circuts-Series" element={ <Series /> } />
                <Route path="/science/activity/Circuts-Parallel" element={ <Parallel /> } />
                <Route path="/science/activity/Dispersion" element={ <Dispersion /> } />
            </Routes>
        </>
    )
}

export { Paths }